<dms-control [dmsTraduction]="this.dmsTraduction" >
	<div class="input-group">
		<input class="textbox form-control" type="tel" [(ngModel)]="tel" >
		<span class="input-group-btn">
			<button class="btn btn-primary" type="button" (click)="callPhone()" >
				<i class="fa fa-phone" style="width: 11px" ></i>
			</button>
		</span>
	</div>
</dms-control>